export default __webpack_public_path__ + "img/aciqui.01c8e9cd.svg";